// extracted by mini-css-extract-plugin
export default {"TopicView__Loading":"TopicView-styles__TopicView__Loading___KhKg"};